module.exports = __webpack_public_path__ + "static/cabina-de-conductor---tablero-de-control-b2abf8969e7f594df49eb7942ac3edcd.jpg";